<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">合约手续费管理</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-table :data="cycleList" border class="data-table">
      <el-table-column label="开始时间">
        <template slot-scope="scope">{{
          scope.row.shareBeginTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="结束时间">
        <template slot-scope="scope">{{
          scope.row.shareEndTime | moment
        }}</template>
      </el-table-column>
      <el-table-column
        label="手续费总额(USDT)"
        prop="totalFeeForUsdt"
      ></el-table-column>
      <!-- <el-table-column label="结束时间">
        <template slot-scope="scope">{{
          scope.row.shareEndTime | moment
        }}</template>
      </el-table-column> -->
      <el-table-column
        label="实际分发手续费总和(USDT)"
        prop="totalFeeRealShare"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalFeeRealShare }}&nbsp;&nbsp;&nbsp;</span>
          <i
            v-if="scope.row.status == 2"
            @click="
              showUpdate(
                'totalVisible',
                scope.row.id,
                scope.row.totalFeeRealShare
              )
            "
            class="el-icon-edit"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="BKK分红总量" prop="sfbTotal"></el-table-column>
      <el-table-column
        label="交易排名奖励总量"
        prop="sftpaTotal"
      ></el-table-column>
      <el-table-column
        label="盈利排名奖励总量"
        prop="sfttvTotal"
      ></el-table-column>
      <el-table-column
        label="有效BKK总量"
        prop="validBkkTotal"
      ></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span>{{ scope.row.status | status }}&nbsp;&nbsp;&nbsp;</span>
          <i
            v-if="scope.row.status == 2 || scope.row.status == 5"
            @click="showUpdate('statusVisible', scope.row.id, scope.row.status)"
            class="el-icon-edit"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click="showTempData(scope.row.id)"
            type="primary"
            size="small"
            >临时数据</el-button
          >
          <el-button
            @click="showRealData(scope.row.id)"
            type="success"
            size="small"
            class="snd-btn"
            >正式数据</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pager.size"
      :page="pager.page"
      :total="cycleListTotal"
      @pageChanged="handlePageChanged"
    >
    </pagination>
    <div class="temp-data-dialog">
      <temp-data ref="tempDataRef"></temp-data>
    </div>
    <div class="real-data-dialog">
      <real-data ref="realDataRef"></real-data>
    </div>
    <div class="real-fee-total">
      <el-dialog :visible.sync="totalVisible" title="修改真实的手续费分发总和">
        <el-input v-model="totalFee"></el-input>
        <div class="btn-wrap">
          <el-button @click="handleUpdateFee()" type="success">提交</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="cycle-status">
      <el-dialog :visible.sync="statusVisible" title="修改状态">
        <el-select v-model="status">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div class="btn-wrap">
          <el-button @click="handleUpdateStatus()" type="success"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import "./store";
import api from "./api";
import { mapActions, mapState } from "vuex";
import coinSelect from "../../components/coinSelect";
import Pagination from "../../components/pagination";
import TempData from "./components/TempData";
import RealData from "./components/RealData";
import { STATUS } from "./constant.js";
export default {
  name: "contractFee",
  components: { coinSelect },
  data() {
    return {
      totalVisible: false,
      statusVisible: false,
      tempDataVisible: false,
      activeCycleId: "",
      totalFee: "",
      status: "",
      pager: {
        page: 1,
        size: 10
      }
    };
  },
  computed: {
    ...mapState("contractFee", ["cycleList", "cycleListTotal"]),
    statusList() {
      let re = [
        {
          value: 0,
          label: STATUS[0]
        },
        {
          value: 2,
          label: STATUS[2]
        },
        {
          value: 3,
          label: STATUS[3]
        },
        {
          value: 4,
          label: STATUS[4]
        },
        {
          value: 5,
          label: STATUS[5]
        },
        {
          value: 6,
          label: STATUS[6]
        },
        {
          value: 7,
          label: STATUS[7]
        }
      ];
      let s = parseInt(this.status);
      if(s == 2 || s == 3) return ([].concat(re[1]).concat(re[2]));
      if(s == 5 || s == 6) return ([].concat(re[4]).concat(re[5]));
    }
  },
  created() {
    //this.findCouponInfo(this.queryCondition);
  },
  methods: {
    ...mapActions("contractFee", [
      "getCycleList",
      "getCycleDetail",
      "updateTotalRealFee",
      "updateStatus"
    ]),
    handlePageChanged(pageVal) {
      this.getCycleList(pageVal);
    },
    showTempData(id) {
      this.$refs["tempDataRef"].showData(id);
    },
    showRealData(id) {
      this.$refs["realDataRef"].showData(id);
    },
    resetActiveCycleId() {
      this.activeCycleId = "";
    },
    showUpdate(type, cycleId, val) {
      this.activeCycleId = cycleId;
      if (type == "totalVisible") this.totalFee = val;
      if (type == "statusVisible") this.status = val;
      this[type] = true;
    },
    handleUpdateFee() {
      this.updateTotalRealFee({
        cycleId: this.activeCycleId,
        realFeeTotal: this.totalFee
      }).then(res => {
        this.$message({
          message: "修改成功！",
          type: "success"
        });
        this.totalVisible = false;
        this.getCycleList({
          page: this.pager.page,
          size: this.pager.size
        });
      });
    },
    handleUpdateStatus() {
      this.updateStatus({
        cycleId: this.activeCycleId,
        status: this.status
      }).then(res => {
        this.$message({
          message: "修改成功！",
          type: "success"
        });
        this.statusVisible = false;
        this.getCycleList({
          page: this.pager.page,
          size: this.pager.size
        });
      });
    }
  },
  filters: {
    status(val) {
      return STATUS[parseInt(val)];
    }
  },
  mounted() {
    this.getCycleList({
      page: this.pager.page,
      size: this.pager.size
    });
  },
  components: {
    Pagination,
    TempData,
    RealData
  }
};
</script>

<style lang="less" scoped>
.data-table {
  margin-top: 30px;
  font-size: 12px;
}
.snd-btn {
  margin: 10px 0px 0px 0px;
}
.btn-wrap {
  margin-top: 30px;
}
.el-icon-edit {
  color: #409eff;
  cursor: pointer;
}
</style>
